import * as VanillaSharing from 'vanilla-sharing';
import analyticsEvent from './analyticsEvent';
import meta from './meta';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (navigator.share !== undefined) {
    document.querySelector('.share__item--all').classList.add('share__item--show');
}

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social);
        });
    });

}



// WEBPACK FOOTER //
// ./js/share.js